import { useTranslation } from "react-i18next";
import React, { useMemo, useState } from "react";
import { SEARCH_MODEL } from "../../../../../../../components/table/Model/TableModel";
import DeductionPolicyCard from "../SubComponents/DeductionPolicyCard";
import { STEPS_ADD_USER_DEDUCTION_POLICY } from "../../DeductionPolicy/Model/Model";
import {TABLES} from "../../../../../../../Apis/Tables";
import {SimpleSearch, SimpleSearchWithId} from "../../../../../../../reduxToolkit/Search/SearchApi";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 *
 * Owns all state and logic for the user deduction expand section.
 * Merges UserDeductionRenderAssignedSectionApp (table state) and the former
 * AssignedDeductionApp (dynamic config + endpoint). Always read-only.
 *
 * @param {Object} props
 * @param {string} props.resource - DEDUCTION_POLICY or EXCLUDED_GLOBAL_DEDUCTIONS key.
 * @param {number|string} props.id - Row id from the expanded table row.
 */
export const AssignedDeductionApp = ({ resource, id, userId, tableNotInformationLegend }) => {
    const { t } = useTranslation();

    const [results, setResults] = useState(SEARCH_MODEL.clearResults());
    const [bodyForExport, setBodyForExport] = useState(null);
    const [searchElement, setSearchElement] = useState('');
    const [search, setSearch] = useState(false);
    const [simpleSearch, setSimpleSearch] = useState(false);
    const [modified, setModified] = useState(false);
    const [isAllChecked, setIsAllChecked] = useState(false);

    /** Renders a single item card in the assigned grid using the shared DeductionPolicyCard. */
    const renderDeductionItem = ({ item }) => <DeductionPolicyCard item={item} />;

    /**
     * Resource-specific config for CustomAssignedItems.
     * DEDUCTION_POLICY uses SimpleSearch against PAYROLL_DEDUCTION_POLICY_USER_ITEM by modelId.
     * EXCLUDED_GLOBAL_DEDUCTIONS uses SimpleSearchWithId against PAYROLL_DEDUCTION_POLICY_EXCLUSION by userId.
     */
    const dynamicConfig = useMemo(() => {
        const base = {
            keyId: 'id',
            tableNotInformationLegend: tableNotInformationLegend,
            searchLabel: 'search_by_name',
            renderAssignedItem: renderDeductionItem,
            model: null,
            modelId: null,
            userId: null,
            endPoint: null
        };
        if (resource === STEPS_ADD_USER_DEDUCTION_POLICY.DEDUCTION_POLICY.KEY) {
            return {
                ...base,
                model: TABLES.PAYROLL_DEDUCTION_POLICY_USER_ITEM,
                endPoint: SimpleSearch,
                modelId: id,
                labelRowsPerPage: 'deductions_per_page'
            };
        }
        if (resource === STEPS_ADD_USER_DEDUCTION_POLICY.EXCLUDED_GLOBAL_DEDUCTIONS.KEY) {
            return {
                ...base,
                model: TABLES.PAYROLL_DEDUCTION_POLICY_EXCLUSION,
                endPoint: SimpleSearchWithId,
                userId: userId,
                labelRowsPerPage: 'deductions_per_page' };
        }
    }, [resource]);

    return {
        t,
        results, setResults,
        setBodyForExport,
        searchElement, setSearchElement,
        search, setSearch,
        simpleSearch, setSimpleSearch,
        modified, setModified,
        isAllChecked, setIsAllChecked,
        dynamicConfig
    };
};
